import * as React from 'react';
import styled from 'styled-components';

export interface ILayout {
  /** Application content. */
  children: React.ReactNode;
  /** Header properties */
  header?: React.ReactNode;
  /** Footer properties */
  footer?: React.ReactNode;
}

const StyledWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
const StyledHeaderWrapper = styled.div`
  flex-shrink: 0;
`;
const StyledContentWrapper = styled.div`
  flex: 1 0 auto;
`;
const StyledFooterWrapper = styled.div`
  flex-shrink: 0;
`;

/**
 * Provides a base layout that places the header at the top, the footer at the bottom and the children fill in the middle.
 *  The Header is not floating but will stay at the top, the footer will always be at the bottom, even if the content isn't that large.
 */
export const Layout: React.FC<ILayout> = ({ header, children, footer }) => {
  return (
    <StyledWrapper>
      <StyledHeaderWrapper>{header}</StyledHeaderWrapper>
      <StyledContentWrapper>{children}</StyledContentWrapper>
      <StyledFooterWrapper>{footer}</StyledFooterWrapper>
    </StyledWrapper>
  );
};
